(() => {
  if (window.jgImageDialogReady) return;
  window.jgImageDialogReady = true;
  let opener;
  const dialog = () => document.getElementById('jg-image-dialog');
  document.addEventListener('click', (event) => {
    const modal = dialog();
    if (!modal || !(event.target instanceof Element)) return;
    if (event.target.closest('.jg-image-dialog__close') || event.target === modal) {
      modal.close();
      return;
    }
    const calendar = event.target.closest('.jg-calendar__link');
    const product = modal.dataset.luckyBag === 'true' && event.target.closest('.product-media-container--image.product-media-container--zoomable');
    if (!calendar && !product) return;
    if (event.target.closest('dialog')) return;
    const source = (calendar || product).querySelector('img');
    if (!source) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    opener = calendar || event.target.closest('button') || product;
    const image = modal.querySelector('img');
    image.src = calendar ? calendar.href : source.currentSrc || source.src;
    image.alt = source.alt || (calendar ? 'イベントカレンダー' : '得袋の商品画像');
    modal.dataset.kind = calendar ? 'calendar' : 'product';
    modal.showModal();
  }, true);
  dialog()?.addEventListener('close', () => opener?.focus?.({preventScroll:true}));
  document.querySelectorAll('.jg-calendar__link').forEach(link => {
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-label', 'カレンダーを拡大する');
  });
})();

